module.exports = __webpack_public_path__ + "src/assets/textures/env/HDRI/mealie_road.jpg";